import { passiveEvent } from '@resn/gozer-misc';
import { autobind } from 'core-decorators';
import TickerService from '@resn/gozer-services/ticker-service';

import getStore from 'core/store';
import { isHandheld } from '@resn/gozer-env';
import { deviceBenchmark } from 'utils/device-benchmark';

const smoothScroll = !isHandheld && !deviceBenchmark.fallback;

const store = getStore();

window.scroll = 0;

class ScrollServiceClass {
    all = [];

    constructor(options = { el: document }) {
        this.el = options.el;
        this.onScroll = this.onScroll.bind(this);

        this.scrollTg = 0;
        this.tLast = 0;

        this.addListeners();

        TickerService.add(this.tick);
    }

    addListeners() {
        this.el.addEventListener('scroll', this.onScroll, passiveEvent);
    }

    removeListeners() {
        this.el.removeEventListener('scroll', this.onScroll);
    }

    add(handler, run = false) {
        this.all.push(handler);
        if (run) handler();
    }

    remove(handler) {
        this.all.splice(this.all.indexOf(handler) >>> 0, 1);
    }

    get scroll() {
        return window.scroll;
    }
    set scroll(scroll) {
        this.setScroll(scroll);
    }

    onScroll() {
        // if (isHandheld) {
        //     this.scrollTg = window.scrollY;
        // }
    }

    setScroll(scroll) {
        window.scrollTo(0, scroll);
        window.scroll = this.scrollTg = scroll;
    }

    setScrollTg(scroll) {
        this.scrollTg = scroll;
    }

    @autobind
    tick() {
        this.scrollTg = window.scrollY;
        // this.scrollTg = document.body.scrollTop;

        if (smoothScroll) {
            if (Math.abs(this.scrollTg - window.scroll) < 0.05) {
                window.scroll = this.scrollTg;

                store.state.scrolling = false;
                store.state.scrollDelta = 0;
            } else {
                window.scroll += (this.scrollTg - window.scroll) * 0.1;

                store.state.scrolling = true;
                store.state.scrollDir = Math.sign(this.scrollTg - window.scroll) || store.state.scrollDir;
                store.state.scrollDelta = Math.abs(this.scrollTg - window.scroll);

                this.all.map((handler) => handler(window.scroll));
            }
        } else {
            store.state.scrollDir = Math.sign(this.scrollTg - window.scroll) || store.state.scrollDir;
            store.state.scrollDelta = Math.abs(this.scrollTg - window.scroll);

            window.scroll = this.scrollTg;

            this.all.map((handler) => handler(window.scroll));
        }

        store.state.scroll = window.scroll;
    }
}

const ScrollService = new ScrollServiceClass();

export default ScrollService;
